import React from 'react'
import HeaderBlock from '../../../../core/components/header-block/HeaderBlock'
import LoadingSwitch from '../../../../core/components/loading-switch/LoadingSwitch'
import HeaderNav from '../../../../core/components/header-nav/HeaderNav'
import {SessionDefaultUserPicture} from '../../../../core/components/default-user-picture/DefaultUserPicture'
import Heading from '../../../../core/components/typography/heading/Heading'
import './loggedInHeader.css'

const LoggedInHeader = ({
  isFetching,
  displayName,
  pictureUrl,
  numSolved,
  numRevisions,
  match,
  location
}) => {
  const tabs = {}
  tabs[`/`] = 'My Journey'
  tabs[`/problems`] = 'Problems'
  tabs[`/contributions`] = 'Contributions'
  const activeTab = tabs[location.pathname]
  const activeState = (
    <div className="logged-in-header__content">
      <div className="logged-in-header__user">
        <SessionDefaultUserPicture className="logged-in-header__picture" />
        <div className="logged-in-header__info">
          <Heading color='white' size='xl' fontWeight='medium'> Hello {displayName}, </Heading>
          <Heading color='white' size='sm' fontWeight='book'> Welcome back to expii. </Heading>
        </div>
      </div>
    </div>
  )
  const loadingState = (
    <div className="logged-in-header__content">
      <div className="logged-in-header__user">
        <div className="logged-in-header__picture logged-in-header__picture--loading" />
        <div className="logged-in-header__info ">
          <div className="logged-in-header__title logged-in-header__title--loading" />
          <div className="logged-in-header__subtitle logged-in-header__subtitle--loading" />
        </div>
      </div>
    </div>
  )
  return (
    <HeaderBlock className="logged-in-header">
      <div className="logged-in-header__container">
        <LoadingSwitch
          activeState={activeState}
          loadingState={loadingState}
          isLoading={isFetching}
        />
        <HeaderNav
          tabs={tabs}
          activeTab={activeTab}
          className="logged-in-header__nav"
        />
      </div>
    </HeaderBlock>
  )
}

export default LoggedInHeader



// WEBPACK FOOTER //
// ./src/domains/home/logged-in-home/components/LoggedInHeader.js